import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Training } from './Training.tsx';
import { Zones } from './Zones.tsx';
import { FTPTest } from './FTPTest.tsx';

type SubTab = 'training' | 'zones' | 'ftp';

const SUB_TAB_META: { id: SubTab; key: string; icon: string }[] = [
  { id: 'training', key: 'trainTab.tabTrainingPlan', icon: '\u{1F4CB}' },
  { id: 'zones', key: 'trainTab.tabZones', icon: '\u{1F4CA}' },
  { id: 'ftp', key: 'trainTab.tabFTP', icon: '\u26A1' },
];

export function TrainTab() {
  const { t } = useTranslation();
  const [active, setActive] = useState<SubTab>('training');

  return (
    <div className="flex flex-col h-full">
      {/* Sub-tab bar */}
      <div className="border-b border-(--color-border) bg-(--color-bg-secondary) px-4 py-3">
        <div className="flex gap-2 overflow-x-auto max-w-3xl mx-auto">
          {SUB_TAB_META.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActive(tab.id)}
              className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium border whitespace-nowrap transition-colors ${
                active === tab.id
                  ? 'bg-blue-500/20 text-blue-400 border-blue-500'
                  : 'bg-(--color-bg-tertiary) text-(--color-text-secondary) border-(--color-border) hover:border-gray-400'
              }`}
            >
              <span>{tab.icon}</span>
              <span>{t(tab.key)}</span>
            </button>
          ))}
        </div>
      </div>

      {/* Sub-tab content */}
      <div className="flex-1 overflow-y-auto">
        {active === 'training' && <Training />}
        {active === 'zones' && <Zones />}
        {active === 'ftp' && <FTPTest />}
      </div>
    </div>
  );
}
